import { render } from "./ProductosEspeciales.vue?vue&type=template&id=4eb0d330"
import script from "./ProductosEspeciales.vue?vue&type=script&lang=js"
export * from "./ProductosEspeciales.vue?vue&type=script&lang=js"

import "./ProductosEspeciales.vue?vue&type=style&index=0&id=4eb0d330&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__